export * from './user-media.adapter';
